export const ERROR_SVG = "https://assets.life.gov.sg/web-frontend-engine/img/common/error.svg";
export const OFFLINE_IMAGE = "https://assets.life.gov.sg/web-frontend-engine/img/common/no-network.png";
export const TIMEOUT_SVG = "https://assets.life.gov.sg/web-frontend-engine/img/icons/get-location-timeout.svg";
